export default __webpack_public_path__ + "static/media/PlayForFun.8771490d.jpg";